import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaAvatar } from "./VaAvatar-0f25af95.mjs";
const VaAvatar = withConfigTransport(_VaAvatar);
export {
  VaAvatar as V
};
//# sourceMappingURL=index-84aec4b5.mjs.map
